// Utopia entry point: load settings and the saves index, then mount the app. zod-config comes
// first so it runs before any schema is built or parsed (ADR-0021). The token and base
// stylesheets are imported next so component stylesheets (imported by their components) follow
// them in the bundle and win ties.
import './zod-config';
import './ui/styles/tokens.css';
import './ui/styles/base.css';
import { render } from 'preact';
import { initStore } from './store';
import { App } from './ui/app';

initStore();

const root = document.getElementById('app');
if (root !== null) render(<App />, root);
